<form #form="ngForm" autocomplete="off">
  <div class="row align-items-end">
    <div class="col-sm">
      <div class="form-group">
        <label for="lastName" class="form-label">Last Name</label>
        <input
          #lastName="ngModel"
          id="lastNameSearch"
          type="text"
          class="form-control field"
          [(ngModel)]="searchRequest.lastName"
          name="lastName"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="firstName" class="form-label">First Name</label>
        <input
          id="firstName"
          type="text"
          class="form-control field"
          [(ngModel)]="searchRequest.firstName"
          name="firstName"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="middleName" class="form-label">Middle Name</label>
        <input
          id="middleName"
          type="text"
          class="form-control field"
          [(ngModel)]="searchRequest.middleName"
          name="middleName"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group" autocomplete="off">
        <label for="phoneNumber" class="form-label">Phone Number</label>
        <input
          id="phoneNumber"
          type="text"
          class="form-control"
          [(ngModel)]="searchRequest.phoneNumber"
          name="phoneNumber"
          numericOnly
          obscure
        />
      </div>
    </div>
  </div>
  <div class="row align-items-start">
    <div class="col-sm">
      <div class="form-group">
        <label for="ein" class="form-label">EIN</label>
        <input id="ein" type="text" class="form-control" [(ngModel)]="searchRequest.ein" name="ein" numericOnly />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="dateOfBirth" class="form-label">Date of Birth</label>
        <cert-date-input
          name="dateOfBirth"
          [(model)]="dateOfBirth"
          [propertyName]="'dateOfBirth'"
          [useObscurity]="obscurityFeatureActive()"
        />
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          type="email"
          class="form-control email-field"
          [(ngModel)]="searchRequest.email"
          name="email"
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="ssn" class="form-label">Social Security</label>
        <input
          id="ssn"
          type="text"
          class="form-control"
          [(ngModel)]="searchRequest.ssn"
          name="ssn"
          numericOnly
          obscure
        />
      </div>
    </div>
    <div class="col-sm">
      <div class="form-group">
        <label for="educatorStakeholderId" class="form-label">Educator Stakeholder Id</label>
        <input
          id="educatorStakeholderId"
          type="text"
          class="form-control"
          [(ngModel)]="searchRequest.educatorStakeholderId"
          name="educatorStakeholderId"
          numericOnly
        />
      </div>
    </div>
  </div>
</form>

@if (searching()) {
  <ngx-skeleton-loader count="5" />
}

<!--results-->
@if (!searching()) {
  <div class="table-container d-flex flex-column">
    @if (educators() && educators()!.length !== 0) {
      <div
        infinite-scroll
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()"
        [scrollWindow]="false"
        [infiniteScrollDistance]="2"
        class="table-responsive"
      >
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Social Security</th>
              <th scope="col">EIN</th>
              <th scope="col">Educator Stakeholder Id</th>
              <th scope="col">Date of Birth</th>
              <th scope="col">Phone Number</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            @for (educator of educators(); track educator.personId) {
              <tr class="educator-row" (click)="goToEducatorManagement(educator.personId)">
                <td obscure>
                  {{ educator.educatorName }}
                  <ng-template #alternateNamesPopoverContent>
                    @for (alternateName of educator.alternateNames; track $index) {
                      <p class="popover-spacing">{{ alternateName }}</p>
                    }
                  </ng-template>
                  @if (educator.alternateNames && educator.alternateNames.length) {
                    <i
                      class="bi bi-info-circle pointer"
                      [ngbPopover]="alternateNamesPopoverContent"
                      (click)="stopPropagation($event)"
                      popoverTitle="Alternate Names"
                      certTooltip="Alternate Names"
                    >
                    </i>
                  }
                </td>
                <td obscure>{{ educator.ssn | SSN: true }}</td>
                <td>
                  {{ educator.ein }}
                  @if (educator.isPrimaryDuplicateEducator === true) {
                    <span [certTooltip]="'This record has been identified the primary record in a group.'"
                      ><i class="bi bi-star-fill text-primary icon-hover ms-1"></i
                    ></span>
                  }
                  @if (educator.isPrimaryDuplicateEducator === false) {
                    <span [certTooltip]="'This record has been identified as a duplicate record in a group.'"
                      ><i class="bi bi-link-45deg text-primary icon-hover ms-1"></i
                    ></span>
                  }
                  @if (educator.isMatchedByMergedEin === true) {
                    <span
                      [certTooltip]="'This record has been returned because the EIN entered matches the EIN of an educator previously merged into it.'"
                      ><i class="merge-icon-warning-sm ms-1"></i
                    ></span>
                  }
                </td>
                <td>{{ educator.educatorStakeholderId | guidFormat }}</td>
                <td obscure>{{ educator.dateOfBirth | date: 'MM/dd/yyyy' }}</td>
                <td obscure>
                  {{ educator.lastActivePhoneNumber | phoneNumber }}
                  <ng-template #phoneNumbersPopoverContent>
                    @for (phoneNumber of educator.alternatePhoneNumbers; track $index) {
                      <p class="popover-spacing">{{ phoneNumber | phoneNumber }}</p>
                    }
                  </ng-template>
                  @if (educator.phoneNumbers && educator.alternatePhoneNumbers.length) {
                    <i
                      class="bi bi-info-circle pointer"
                      [ngbPopover]="phoneNumbersPopoverContent"
                      (click)="stopPropagation($event)"
                      popoverTitle="Phone Numbers"
                    >
                    </i>
                  }
                </td>
                <td obscure>
                  {{ educator.lastActiveEmail }}
                  <ng-template #emailsPopoverContent>
                    @for (email of educator.alternateEmails; track $index) {
                      <p class="popover-spacing">{{ email }}</p>
                    }
                  </ng-template>
                  @if (educator.emails && educator.alternateEmails.length) {
                    <i
                      class="bi bi-info-circle pointer"
                      [ngbPopover]="emailsPopoverContent"
                      (click)="stopPropagation($event)"
                      popoverTitle="Emails"
                    >
                    </i>
                  }
                </td>
              </tr>
            }
            <tr>
              <td colspan="6" class="text-center">
                @if (!endOfResults()) {
                  <p class="text-secondary my-auto">Scroll down for more results</p>
                } @else {
                  <p class="text-secondary my-auto">No more results exist</p>
                }
              </td>
            </tr>
          </tbody>
        </table>

        @if (scrollSearching()) {
          <ngx-skeleton-loader count="5" />
        }
      </div>
    }
    @if (educators() && educators()!.length === 0) {
      <div class="my-2 d-flex justify-content-center">
        <h5>No Results</h5>
      </div>
    }
  </div>
}
